import "./_Video.scss";

export interface IVideo
{
	Container?: HTMLElement;
	Player?: HTMLElement;
	MediaEl?: HTMLVideoElement;
}

export class Video
{
	static LibrariesDownloaded = false;
	static Overlay: HTMLElement;
	static Overlays: NodeListOf<HTMLElement>;
	static Videos: IVideo[] = [];
	static Playing = -1;

	constructor()
	{
		this.ConfigureVideo();
	}
	private ConfigureVideo = (): void =>
	{
		const videos = document.querySelectorAll<HTMLElement>(".videos .video");

		videos.forEach((container: HTMLElement) =>
		{
			if (container !== null)
			{
				const player = container.querySelector(".video__player") as HTMLElement;
				const MediaEl = container.querySelector(".video__media") as HTMLVideoElement;

				container.addEventListener("click", (e) =>
				{
					e.stopPropagation();
				});

				container.addEventListener("pointerdown", (e) =>
				{
					e.stopPropagation();
				});

				container.addEventListener("keydown", (e) =>
				{
					e.stopPropagation();
				});

				if (player !== null && MediaEl !== null)
				{
					Video.Videos.push({
						Container: container,
						Player: player,
						MediaEl: MediaEl
					});

					MediaEl.addEventListener("play", (event) =>
					{
						const target = event.currentTarget as HTMLElement;

						if (target !== null)
						{
							const dataVideo = target.getAttribute("data-video");
							const playerIndex = dataVideo !== null ? parseInt(dataVideo, 10) : NaN;

							if (!isNaN(playerIndex))
							{
								Video.Playing = playerIndex;
							}
							else
							{
								Video.Playing = -1;
							}
						}
					});
				}

				MediaEl.addEventListener("ended", (event) =>
				{
					Video.Playing = -1;
				});

				MediaEl.addEventListener("pause", (event) =>
				{
					Video.Playing = -1;
				});
			}
		});
	};

	static DownloadVideoPlayer = async (): Promise<void> =>
	{
		if (!Video.LibrariesDownloaded)
		{
			await import("@videojs/html/video/player");
			await import("@videojs/html/video/skin");
			await import("@videojs/html/media/hls-video");
		}
		else
		{
			return;
		}
	};

	static Play = (index: number): void =>
	{
		const toPlay = Video.Videos[index];

		Video.Stop();

		if (typeof toPlay.MediaEl !== "undefined")
		{
			const player = toPlay.MediaEl;

			player.play().catch(() =>
			{
				console.log('Video playback failed');
				player.muted = true;
				player.play();
			});
		}
	};

	static Stop = (): void =>
	{
		const playing = Video.Playing;

		if (playing > -1)
		{
			const MediaEl = Video.Videos[playing].MediaEl;

			if (typeof MediaEl !== "undefined")
			{
				MediaEl.pause();
				MediaEl.currentTime = 0;
			}
		}
	};
}